import { graphql } from "react-relay";

export const CompleteOnboardingMutation = graphql`
  mutation CompleteOnboardingMutation {
    completeOnboarding {
      success
      error
    }
  }
`;
